import { useLocation, Navigate } from "react-router-dom";
import { basePort, headers } from "../../module_auth/AuthService"
import { useState, useEffect } from 'react';

export function RedirectToNewUrlBlog() {
    const [slug, setSlug] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    useEffect(() => {
        const url = basePort + "/get/blog/" + id;
        fetch(url, {
            method: "GET",
            headers: headers,
        })
            .then((response) => response.json())
            .then((response) => {
                setSlug(response.slug);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    }, [id]);

    if (loading) {
        return <p>Loading...</p>;
    }
    if (slug) {
        return <Navigate to={`/blog/${id}/${slug}`} replace />;
    }
    return <Navigate to={`/`} replace />;
}

export function RedirectToNewUrlNews() {
    const [slug, setSlug] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    useEffect(() => {
        const url = basePort + "/get/news/" + id;
        fetch(url, {
            method: "GET",
            headers: headers,
        })
            .then((response) => response.json())
            .then((response) => {
                setSlug(response.slug);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    }, [id]);

    if (loading) {
        return <p>Loading...</p>;
    }
    if (slug) {
        return <Navigate to={`/news/${id}/${slug}`} replace />;
    }
    return <Navigate to={`/`} replace />;
}